<template>
  <div class="min-w-[274px] md:min-w-fit h-[274px] flex shrink-0 relative" :style="{flexBasis: cardWidth}" @mouseover="hovered()" @mouseleave="unhovered()">
    <div class="w-full h-full  absolute bottom-0 flex flex-col items-left justify-between p-8" :class="[hover ? 'bg-infra-violette' : 'h-72 bg-very-light-grey']">
      <p class="text-display-5 font-light text-left review-max-lines" :class="[hover ? 'text-white' : 'text-black']">
        {{ body }}
      </p>
      <h4 class="text-base lg:text-smaller font-normal text-left" :class="[hover ? 'text-white' : 'text-infra-violette']">
        {{ name }}
      </h4>
    </div>
  </div>
</template>
<script setup>
defineProps({
  body: {
    type: String,
    default: ''
  },
  name: {
    type: String,
    default: ''
  },
  cardWidth: {
    type: String,
    default: null
  }
})
const hover = ref(false)
const hovered = () => {
  hover.value = true
}
const unhovered = () => {
  hover.value = false
}
</script>
  <style>
  .review-item {
        color: white;
        font-weight: bold;
        font-size: 1.5em;
        text-align: center;
        flex-grow: 0;
        flex-shrink: 0;
        height:auto;
    }
    .review-item::before {
        content:'';
    }
    .review-max-lines {
      overflow: hidden;
      width: 100%;
      display: -webkit-box;
      -webkit-line-clamp: 6;
      -webkit-box-orient: vertical;
    }
    .card-carousel-icon {
      /* padding: 7px 9px; */
      color: #222120;
      background-color: #FFF5F0 !important;
    }
  </style>
